function createSizeArr(
  start: number,
  end: number,
  callback: (size: string | number) => { text: string }
) {
  const arr: number[] = [];
  for (let i = start; i < end + 1; i++) {
    arr.push(i);
  }
  return arr.map(callback);
}

export const sizeData = [
  {
    text: "Alphabetic code(字母码)",
    type: 1,
    list: [
      { text: "6XL" },
      { text: "5XL" },
      { text: "4XL" },
      { text: "3XL" },
      { text: "2XL" },
      { text: "XL" },
      { text: "L" },
      { text: "M" },
      { text: "S" },
      { text: "XS" },
      { text: "F" },
    ],
  },
  {
    text: "Digital codes(数字码)",
    type: 2,
    list: [
      { text: "US22W" },
      { text: "US18" },
      { text: "US16" },
      { text: "US14" },
      { text: "US12" },
      { text: "US10" },
      { text: "US8" },
      { text: "US6" },
      { text: "US4" },
    ],
  },
  {
    text: "Memory(内存)",
    type: 3,
    list: [
      { text: "1GB" },
      { text: "2GB" },
      { text: "4GB" },
      { text: "6GB" },
      { text: "8GB" },
      { text: "16GB" },
      { text: "32GB" },
      { text: "64GB" },
      { text: "128GB" },
      { text: "256GB" },
      { text: "512GB" },
      { text: "1TB" },
    ],
  },
  {
    text: "women shoes(女鞋)",
    type: 4,
    list: [
      { text: "35" },
      { text: "36" },
      { text: "37" },
      { text: "38" },
      { text: "39" },
      { text: "40" },
      { text: "41" },
      { text: "42" },
      { text: "43" },
    ],
  },
  {
    text: "men shoes(男鞋)",
    type: 5,
    list: [
      { text: "38" },
      { text: "39" },
      { text: "40" },
      { text: "41" },
      { text: "42" },
      { text: "43" },
      { text: "44" },
      { text: "45" },
      { text: "46" },
      { text: "47" },
      { text: "48" },
    ],
  },
  {
    text: "童鞋",
    type: 10,
    list: createSizeArr(19, 36, (size) => {
      return {
        text: String(size),
      };
    }),
  },
  {
    text: "baby shoes(婴儿鞋)",
    type: 6,
    list: [
      { text: "12cm" },
      { text: "13cm" },
      { text: "14cm" },
      { text: "15cm" },
    ],
  },
  {
    text: "ring size(戒指尺码)",
    type: 7,
    list: [
      { text: "4码" },
      { text: "5码" },
      { text: "6码" },
      { text: "7码" },
      { text: "8码" },
      { text: "9码" },
      { text: "10码" },
      { text: "11码" },
      { text: "12码" },
      { text: "13码" },
      { text: "14码" },
    ],
  },
  {
    text: "Bra Size(文胸尺码)",
    type: 8,
    list: [
      { text: "32A(70A)" },
      { text: "34A(75A)" },
      { text: "36A(80A)" },
      { text: "38A(85A)" },
      { text: "40A(90A)" },
      { text: "42A(95A)" },
      { text: "44A(100A)" },
      { text: "32B(70B)" },
      { text: "34B(75B)" },
      { text: "36B(80B)" },
      { text: "38B(85B)" },
      { text: "40B(90B)" },
      { text: "42B(95B)" },
      { text: "44B(100B)" },
      { text: "32C(70C)" },
      { text: "34C(75C)" },
      { text: "36C(80C)" },
      { text: "38C(85C)" },
      { text: "40C(90C)" },
      { text: "42C(95C)" },
      { text: "44C(100C)" },
      { text: "46C(105C)" },
      { text: "48C(110C)" },
      { text: "50C(115C)" },
      { text: "52C(120C)" },
      { text: "32D(70D)" },
      { text: "34D(75D)" },
      { text: "36D(80D)" },
      { text: "38D(85D)" },
      { text: "40D(90D)" },
      { text: "42D(95D)" },
      { text: "44D(100D)" },
      { text: "46D(105D)" },
      { text: "48D(110D)" },
      { text: "50D(115D)" },
      { text: "52D(120D)" },
      { text: "34E(75E)" },
      { text: "36E(80E)" },
      { text: "38E(85E)" },
      { text: "40E(90E)" },
      { text: "42E(95E)" },
      { text: "44E(100E)" },
      { text: "46E(105E)" },
      { text: "48E(110E)" },
      { text: "50E(115E)" },
      { text: "52E(120E)" },
      { text: "36F(80F)" },
      { text: "38F(85F)" },
      { text: "40F(90F)" },
      { text: "42F(95F)" },
      { text: "44F(100F)" },
      { text: "46F(105F)" },
      { text: "48F(110F)" },
      { text: "50F(115F)" },
      { text: "52F(120F)" },
      { text: "36G(80G)" },
      { text: "38G(85G)" },
      { text: "40G(90G)" },
      { text: "42G(95G)" },
      { text: "44G(100G)" },
      { text: "46G(105G)" },
      { text: "48G(110G)" },
      { text: "50G(115G)" },
      { text: "52G(120G)" },
      { text: "54G(125G)" },
      { text: "46B(105B)" },
    ],
  },
  {
    text: "Baby clothes size(婴童装尺码)",
    type: 9,
    list: [
      { text: "60" },
      { text: "70" },
      { text: "80" },
      { text: "90" },
      { text: "100" },
      { text: "110" },
      { text: "120" },
      { text: "130" },
      { text: "140" },
      { text: "150" },
      { text: "160" },
    ],
  },
];
